<!-- 问题行动 组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="chat-text">
        现在，想想你前面所描述的问题和想实现的目标，选择一种你可能会考虑改变的行为。
        <div class="chat-flex">

          <div style="white-space: nowrap">问题、目标与动机：</div>
          <PickerPopup
            v-if="isCanEdit"
            v-model="activity"
            :columns="problemArr"
            @input="changeActivity"
          >
            <div class="sleect-input">
              {{ activity || "请选择" }}
              <img class="bottom-icon" src="@/assets/images/select_icon.png" alt="选择" />
            </div>
          </PickerPopup>
          <div v-if="!isCanEdit">{{ activity }}</div>
        </div>
        <div>（可从以上填写的“问题与目标”中直接选中填入）</div>
      </div>
      <div class="problem">
        <div class="problem-item-box" v-for="(item, index) in actionsArr" :key="index">
          <div class="problem-item">
            {{ item.title }}
          </div>
          <div class="problem-item">
            <div class="item-label">用户作答：</div>
            <input
              v-if="isCanEdit"
              class="item-value"
              v-model="item.action"
              type="text"
              placeholder="点击输入答案"
            />
            <div v-if="!isCanEdit">{{ item.action }}</div>
          </div>
        </div>
      </div>
      <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
    </div>
    <!-- <div class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
import { Form } from "@/components";
import { Toast } from "vant";
const { PickerPopup } = Form;
export default {
  name: "ChatActions",
  components: { PickerPopup },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      actionsArr: [
        {
          title: "想想不做这些改变有什么好处，为什么维持现状可能会更好？",
          action: "",
        },
        {
          title: "不做这些改变会有哪些危害呢？为什么不能维持原状了？",
          action: "",
        },
        {
          title:
            "改变有哪些好处呢？改变之后我可以？实现目标后我会是什么样的？我的生活会有什么不同？",
          action: "",
        },
        {
          title: "改变需要付出哪些代价？我在改变中可能会面临哪些困难？",
          action: "",
        },
      ],
      activity: "",
      problemArr: [],
    };
  },
  created() {},
  mounted() {
    if (this.isCanEdit) {
      let instanceData = this.cardData.step_data.instance_data;
      if (instanceData[instanceData.length - 1].answer.goals.length) {
        this.problemArr = instanceData[instanceData.length - 1].answer.goals.map(
          (item) => {
            return {
              value: item.goal,
              label: item.goal,
            };
          }
        );
      }
    } else {
      if (this.nextData.step_data.survey.qstList[0].answer.actions) {
        this.actionsArr = this.nextData.step_data.survey.qstList[0].answer.actions;
        this.activity = this.nextData.step_data.survey.qstList[0].answer.selectVal;
      }
    }
  },
  methods: {
    confirmFn() {
      if (!this.activity) {
        Toast("请选择目标与动机");
        return;
      }
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: "my_actions_qst",
                answer: {
                  actions: this.actionsArr,
                  selectVal: this.activity,
                },
              },
            ],
          },
        },
      };
      this.$emit("confirmFn", useData);
    },
    changeActivity(index) {
      this.activity = this.problemArr[index].value;
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 342px;
  border-radius: 12px 12px 12px 0px;
  padding: 10px 12px;
  background: #e8e3fc;
  box-sizing: border-box;
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;

    .chat-flex {
      display: flex;
      align-items: center;
      .sleect-input {
        width: 186px;
        height: 22px;
        line-height: 22px;
        border-radius: 6px;
        background: #ffffff;
        margin: 0 4px;
        padding: 0 10px;
        box-sizing: border-box;
        .bottom-icon {
          float: right;
          width: 12px;
          height: 12px;
          margin-top: 6px;
        }
      }
    }
    .chat-p {
      margin-top: 20px;
    }
  }
  .problem {
    margin-top: 20px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
    color: rgba(59, 59, 59, 1);

    .problem-item-box {
      margin-top: 6px;
    }
    .problem-item {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      font-size: 12px;
      color: $text-color;
      .item-label {
        min-width: 44px;
        font-size: 12px;
        font-weight: 500;
        color: $text-color;
      }
      .item-value {
        width: 200px;
        height: 23px;
        border-radius: 6px;
        background: rgba(255, 255, 255, 1);
        color: $text-color;
        padding: 4px;
        box-sizing: border-box;
        border: none;
        font-size: 12px;
        display: flex;
        align-items: center;

        &::placeholder {
          font-size: 10px;
          font-weight: 300;
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
  .confirm-btn {
    width: 75.94px;
    height: 25.31px;
    border-radius: 12.66px;
    background: #ad7eff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10.13px;
    font-weight: 400;
    letter-spacing: 0.23px;
    color: rgba(255, 255, 255, 1);
    border: none;
    margin: 10px auto 0;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
